'use client';

import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { cn } from '@ifixit/ui/lib/utils';
import type { MouseEvent, MouseEventHandler } from 'react';

export interface RibbonBannerData {
   title: string;
   displayText: string;
}

export interface RibbonBannerProps {
   ribbon: RibbonBannerData | null;
   page: string;
   onClick?: MouseEventHandler;
   className?: string;
}

export function RibbonBanner({ ribbon, page, onClick, className }: RibbonBannerProps) {
   if (!ribbon) {
      return null;
   }

   return (
      <aside
         className={cn(
            // FIXME: text-base is a temp PHP/NextJS base-font sync
            'flex items-center justify-center bg-brand-500 p-4 text-center text-base text-white min-h-[52px]',
            className
         )}
      >
         <div
            // tighten multi-line text; links inherit white + underline, never wrap
            className="leading-tight [&_a]:whitespace-nowrap [&_a]:text-inherit [&_a]:underline [&_p]:my-0 [&_strong]:text-inherit"
            onClick={event => {
               trackRibbonBannerLinkClick(ribbon, page, event);
               onClick?.(event);
            }}
            dangerouslySetInnerHTML={{ __html: ribbon.displayText }}
         />
      </aside>
   );
}

function trackRibbonBannerLinkClick(
   ribbon: RibbonBannerData,
   page: string,
   event: MouseEvent
): void {
   const element = event.target;
   if (element instanceof HTMLAnchorElement && element.href) {
      trackAnalyticsCustomEvent({
         eventCategory: 'Ribbon Banner',
         eventAction: `${ribbon.title} - Link - Clicked`,
         eventName: page,
      });
   }
}
